import { useContext } from "react";
import { ParagraphText } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";

// "Attach <name> to this transaction?" for the attach-contact confirm modals. The whole phrase
// comes from one key so each language sets its own word order ("{name} کو اس ٹرانزیکشن سے
// منسلک کریں؟" in Urdu). Direction comes from the template, not dir="auto": the Urdu line
// starts with the (usually Latin) contact name, which would wrongly make it left-to-right.
const AttachContactMessage = ({ name = "", id }) => {
  const [I18n] = useContext(LanguageContext);
  const template = I18n.attach_contact_confirm || "Attach {name} to this transaction?";
  const [beforeName, afterName = ""] = template.split("{name}");

  return (
    <ParagraphText
      id={id}
      className="fontSize16 fontWeight500 newFontColor"
      dir={/[؀-ۿ]/.test(template) ? "rtl" : "ltr"}
      // rtl would push the line to the right; keep it aligned with the modal's subtitle below
      style={{ textAlign: "left" }}
    >
      {beforeName}
      <span className="fontWeight700">{name}</span>
      {afterName}
    </ParagraphText>
  );
};

export default AttachContactMessage;
